import {
  useQuery,
  useQueryClient,
  keepPreviousData,
  skipToken,
} from '@tanstack/react-query';

import { fetchInternalBalanceHistory } from 'api/apiExchange';
import { useWebsocketEventListener } from 'components/hooks';
import { getPaginationPerPageLimit } from 'config/configUtils';
import { PAGINATION_PAGES_LIMIT } from 'config/constants';
import { useSelector } from 'reduxState/store';

import { minutes } from './utils';

export const useGlobalBalanceHistoryQueriesInvalidator = () => {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const queryClient = useQueryClient();

  //   const mutate = useMutation({
  //     mutationFn: addTodo,
  //     onSuccess: (data, variables, context) => {
  //     },
  //     onError: (error, variables, context) => {
  //     },
  //     onSettled: (data, error, variables, context) => {
  //     },
  //   });

  // const fetchAndUpdateWithdrawal = (withdrawalId: string) =>
  //   fetchWithdrawal(wallet.walletAddress, withdrawalId).then(
  //     updatedWithdrawal =>
  //       setHistoryEvents(events =>
  //         events.map(event =>
  //           event.type === 'withdrawal' &&
  //           updatedWithdrawal.withdrawalId === event.withdrawalId
  //             ? {
  //                 ...event,
  //                 ...updatedWithdrawal,
  //                 assetContractAddress: event.assetContractAddress,
  //               }
  //             : event
  //         )
  //       )
  //   );

  useWebsocketEventListener('withdrawals', _message => {
    queryClient.invalidateQueries({
      queryKey: ['balanceHistory', walletAddress],
    });
  });

  useWebsocketEventListener('deposits', _message => {
    queryClient.invalidateQueries({
      queryKey: ['balanceHistory', walletAddress],
    });
  });

  useWebsocketEventListener('webclient', message => {
    if (message.data.event !== 'transaction_settled') {
      return;
    }
    if (message.data.action === 'withdraw') {
      // Note: we can be more clever here to not reload whole list
      //  - but it's the most safe/easiest option
      queryClient.invalidateQueries({
        queryKey: ['balanceHistory', walletAddress],
      });
      // fetchAndUpdateWithdrawal(transaction.id);
    }
  });
};

export const PAGE_LIMIT = getPaginationPerPageLimit(50);

// We should refresh table when one of conditions is met:
//  1. when pending deposit was removed = there was success/failure
//  2. user wallet changed
export const useBalanceHistoryPaginatedQuery = (page: number) => {
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  return useQuery({
    queryKey: ['balanceHistory', walletAddress, 'USD', page],
    queryFn:
      !walletAddress || page > PAGINATION_PAGES_LIMIT
        ? skipToken
        : () =>
            fetchInternalBalanceHistory({
              wallet: walletAddress,
              page,
              limit: PAGE_LIMIT,
            }),
    staleTime: minutes(10),
    refetchOnWindowFocus: false,
    refetchInterval: minutes(5),
    // Required nice UX on pagination
    placeholderData: keepPreviousData,
  });
};
